import store from "@/store/store";

function getIntraRedirectUrl(intraEndpoint) {
  return "https://www.cmem-mat.info/Account/AutoLogin.aspx?key=" + store.state.self.AutoLoginCle + (intraEndpoint ? ("&returnurl=" + encodeURIComponent(intraEndpoint)) : "");
}

function getDroneRedirectUrl(droneEndpoint) {
  return getIntraRedirectUrl("~/Pages/Commun/Drone.aspx?url=" + droneEndpoint)
}

export default {
  getIntraRedirectUrl,
  getDroneRedirectUrl
}
export {
  getIntraRedirectUrl,
  getDroneRedirectUrl
}



// WEBPACK FOOTER //
// ./src/helpers/getRedirectUrlHelper.js